import { Navigate, useLocation, useParams } from 'react-router-dom';

// Map a legacy "/user/<id>/<rest>" path (from before user ids were dropped
// from URLs) to its current equivalent. The id was never used for access —
// the auth cookie identifies the user — so it is simply discarded.
export function legacyUserPathToCurrent(rest = '') {
  const path = rest.replace(/^\/+|\/+$/g, '');
  if (!path) return '/';

  // The user's own pages: my_<page>[/...] → /me/<page>[/...]
  const mine = path.match(/^my_(profile|benchmarks|drives|systems|blogs)(\/.*)?$/);
  if (mine) return `/me/${mine[1]}${mine[2] ?? ''}`;

  // Blog editor moved under the user's blog posts
  if (path === 'blog/new') return '/me/blogs/new';
  const blogEdit = path.match(/^blog\/edit\/(.+)$/);
  if (blogEdit) return `/me/blogs/edit/${blogEdit[1]}`;

  // Signed-in duplicate of a public drive page
  const drive = path.match(/^drive\/(.+)$/);
  if (drive) return `/all_drives/drive/${drive[1]}`;

  // all_*, admin/*, download_* — same path without the prefix
  return `/${path}`;
}

// Catch-all for /user/:legacyId/* so old bookmarks and e-mailed links keep working
export default function LegacyUserRedirect() {
  const { '*': rest } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`${legacyUserPathToCurrent(rest)}${search}${hash}`} replace />;
}
